import type { ModuleStorage } from "app/pages/sales-intelligence/services/storage/types";

import type { SaveSearchStorage } from "./types";

const SAVE_SEARCH_EXPORT_TRIGGER_STORAGE_KEY = "shouldSaveSearchExportTriggerActivate";

export default function createSavedSearchesStorage(storage: ModuleStorage): SaveSearchStorage {
    return {
        getExportTriggerShouldActivate() {
            return storage.retrieve(SAVE_SEARCH_EXPORT_TRIGGER_STORAGE_KEY) !== false;
        },
        setExportTriggerShouldActivate(isVisible: boolean) {
            storage.persist(SAVE_SEARCH_EXPORT_TRIGGER_STORAGE_KEY, isVisible);
        },
    };
}
